const { createInspirationTiles } = require('../shop/tiles/inspiration-tile-factory');

class SearchInspirationTileListController {
    constructor(settings, analyticsService, searchService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
    }

    createTiles(result) {
        return {
            items: createInspirationTiles(result.items),
            totalRecordCount: result.totalRecordCount,
        };
    }

    pushToAnalytics(result) {
        if (this.searchService.isHeaderSearch) {
            this.searchService.isHeaderSearch = false;
            const searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    searchKeyword: this.searchTerm,
                    listKeywords: this.multisearchItems,
                    searchResult: result,
                    refinementsUsed: 'Articles',
                    searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed',
                },
                type: this.analyticsService.mapperTypes.customEvent.search.success,
            });

            this.searchService.isAutocompleteSearch = false;
        }

        this.analyticsService.push({
            data: {
                type: 'articles',
                searchKeyword: this.searchTerm,
                listKeywords: this.multisearchItems,
                pageNumber: this.pageNumber,
                searchResult: result,
            },
            type: this.analyticsService.mapperTypes.search.result,
        });

        return result;
    }

    getTiles(pageSize, pageNumber) {
        return this.searchService.doSearchArticles(this.searchTerm, pageSize, pageNumber)
            .then(result => this.createTiles(result))
            .then(result => this.pushToAnalytics(result));
    }
}

SearchInspirationTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService'];

const searchInspirationTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        pageNumber: '<',
    },
    controller: SearchInspirationTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber)"
            should-remember-sort="::$ctrl.settings.search.shouldRememberSort">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchInspirationTileListController,
    searchInspirationTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-inspiration-tile-list.component.js